"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FetchError_1 = __importDefault(require("../errors/FetchError"));
class FetchClient {
    baseURL;
    headers;
    constructor(src = {}) {
        this.baseURL = src.baseURL || '';
        this.headers = {
            'Content-Type': 'application/json',
            ...src.headers
        };
    }
    async request(path, init = {}) {
        const url = `${this.baseURL}/${path}`;
        const config = {
            ...init,
            headers: this.headers,
            method: init.method || 'GET',
            body: init.body && JSON.stringify(init.body),
        };
        /** Merge Headers */
        if (Array.isArray(init.headers)) {
            init.headers.forEach(([k, v]) => config.headers[k] = v);
        }
        else if (init.headers instanceof Headers) {
            init.headers.forEach((v, k) => config.headers[k] = v);
        }
        else {
            config.headers = { ...config.headers, ...init.headers };
        }
        const res = await fetch(url, config);
        if (!res.ok) {
            throw new FetchError_1.default({
                url,
                statusCode: res.status,
                message: await res.text() || `HTTP ERROR! Status: ${res.status}`,
            });
        }
        let body;
        const contentType = res.headers.get('Content-Type');
        if (contentType && contentType.includes('application/json')) {
            body = await res.json();
        }
        else {
            body = await res.text();
        }
        return {
            url,
            body,
            headers: res.headers,
            statusCode: res.status,
            method: config.method,
        };
    }
    async get(path, headers = {}) {
        return this.request(path, { method: 'GET', headers });
    }
    async post(url, body, headers = {}) {
        return this.request(url, { method: 'POST', headers, body });
    }
}
exports.default = FetchClient;
